import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Aseguradora } from '@app/interfaces/gestion-vehicular/aseguradora.interface';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-nueva-aseguradora',
  standalone: false,
  templateUrl: './nueva-aseguradora.component.html',
  styleUrl: './nueva-aseguradora.component.scss'
})
export class NuevaAseguradoraComponent {
  config = inject(DynamicDialogConfig);
  ref = inject(DynamicDialogRef);

  opcionesSelect = {
    tipo: [
      { label: 'Seleccione', value: 'seleccione' },
    ],

    alcance: [
      { label: 'Propio', value: '0' },
      { label: 'Terceros', value: '1' }
    ]
  }

  form = new FormGroup({
    // nombre: new FormControl('', [Validators.required]),
    razon_social: new FormControl('', [Validators.required]),
    // poliza: new FormControl('', [Validators.required]),
    // desde: new FormControl(''),
    // hasta: new FormControl('', [Validators.required]),
    // tipo: new FormControl(''),
    // alcance: new FormControl('')
  });

  confirmar() {
    if (this.form.valid) {
      this.ref.close(this.form.value as Aseguradora);
    } else {
      this.form.markAllAsTouched();
    }
  }

  cancelar() {
    this.ref.close();
  }

}
